import { createStore, UseStore, get, set, update, del, values, setMany } from 'idb-keyval/dist/esm-compat';

import { Api } from '../../typings/api';
import Utils from '../index';

class IndexedDBManager {
	private static prefix: string;
	private static NOTES_DB_NAME = 'gallApp-notes';
	private static NOTES_STORE_NAME = 'notes';

	public static setGalleryPrefix(int: number, login?: string): void {
		this.prefix = Utils.getGalleryPrefix(int, login);
	}

	public static getNote(id: number): Promise<Api.NoteData | undefined> {
		const store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);

		return IndexedDBManager.getItem<Api.NoteData>(id, store);
	}

	public static getNotes(): Promise<Api.NoteData[]> {
		const store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);

		return IndexedDBManager.getAllItems<Api.NoteData>(store);
	}

	public static setNote(id: number, data: Api.NoteData): Promise<void> {
		const store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);

		return IndexedDBManager.setItem(id, data, store);
	}

	public static setNotes(notes: Api.NoteData[]): Promise<void> {
		const store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);
		const entries: [number, Api.NoteData][] = [];
		notes.forEach(note => entries.push([note.id, note]));

		return IndexedDBManager.setItems(entries, store);
	}

	public static updateNote(id: number, newData: Api.NoteData): Promise<void> {
		const store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);
		const updater = (oldData: Api.NoteData) => ({ ...oldData, ...newData });

		return IndexedDBManager.updateItem(id, updater, store);
	}

	public static removeNote(id: number): Promise<void> {
		const store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);

		return IndexedDBManager.removeItem(id, store);
	}

	private static openStore(dbName: string, storeName: string): UseStore {
		// opens existing store or creates a new if it doesn't exist
		return createStore(`${this.prefix}-${dbName}`, storeName);
	}

	private static getItem<T>(key: IDBValidKey, store: UseStore): Promise<T | undefined> {
		return get(key, store);
	}

	private static getAllItems<T>(store: UseStore): Promise<T[]> {
		return values(store);
	}

	// tslint:disable-next-line no-any
	private static setItem(key: IDBValidKey, value: any, store: UseStore): Promise<void> {
		return set(key, value, store);
	}

	// tslint:disable-next-line no-any
	private static setItems(items: [number, any][], store: UseStore): Promise<void> {
		return setMany(items, store);
	}

	private static updateItem<T>(key: IDBValidKey, updater: (oldValue: T | undefined) => T, store: UseStore): Promise<void> {
		return update(key, updater, store);
	}

	private static removeItem(key: IDBValidKey, store: UseStore): Promise<void> {
		return del(key, store);
	}
}

export default IndexedDBManager;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/indexedDB/manager.ts